// extracted by mini-css-extract-plugin
export default {"fourColumnLayout":"SignupUserType_fourColumnLayout__c3ykk","column":"SignupUserType_column__Hy+qC"};